import { Dialog, DialogContent } from '@/components/ui/dialog'

interface StepPhotoFullscreenModalProps {
  open: boolean
  imageUrl: string | null
  caption: string | null
  onClose: () => void
}

/**
 * Phase 8 — fullscreen viewer for a single Step Photo. Renders the display-size variant,
 * letting the device's native pinch-zoom handle the zoom interaction on mobile.
 */
export const StepPhotoFullscreenModal = ({
  open,
  imageUrl,
  caption,
  onClose,
}: StepPhotoFullscreenModalProps) => {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-4xl">
        {imageUrl && (
          <div className="space-y-2">
            <img
              src={imageUrl}
              alt={caption ?? 'Step photo'}
              className="max-h-[80vh] w-full rounded-md object-contain"
              loading="eager"
            />
            {caption && <p className="text-center text-sm text-muted-foreground">{caption}</p>}
          </div>
        )}
      </DialogContent>
    </Dialog>
  )
}
